import Vue from 'vue'
import VueRouter from 'vue-router'

// Vue模块全局加载,使用VueRouter模块
Vue.use(VueRouter)

// 创建路由表(最常用的修改)
var routes = [
	{
		path: '*',
		redirect: '/'
	},
	{
		path: '/',
		name: 'PageView',
		component: (resolve) => require(['../views/PageView'], resolve),
		children: [
			{
				path: '/',
				redirect: '/home'
			},
			{
				path: '/home',
				name: 'home',
				component: () => import('../views/home.vue'),
				meta: {
					title: '首页'
				}
			},
			//活动招募
			{
				path: '/zyAct',
				name: 'zyAct',
				component: () => import('../views/VoluntaryService/VoluntaryActivities/zyAct.vue')
			},
			//活动招募详情
			{
				path: '/ActDetail',
				name: 'ActDetail',
				component: () => import('../views/VoluntaryService/VoluntaryActivities/ActDetail.vue')
			},
			//文明积分
			{
				path: '/exchangeList',
				name: 'exchangeList',
				component: () => import('../views/exchange/List.vue')
			},
			//文明积分详情
			{
				path: '/exchangeDetail',
				name: 'exchangeDetail',
				component: () => import('../views/exchange/detail.vue')
			},
			// 实践动态
			{
				path: '/PractActivies',
				name: 'PractActivies',
				component: () => import('../views/PraAct/PractActivies.vue')
			},
			//实践动态详情
			{
				path: '/PracActDetail',
				name: 'PracActDetail',
				component: () => import('../views/PraAct/PracActDetail.vue')
			},
			//轮播图详情
			{
				path: '/broadcastDetails/:id',
				name: 'broadcastDetails',
				component: () => import('../views/broadcastDetails.vue')
			},
			//注册页面
			{
				path: '/register',
				name: 'register',
				component: () => import('../views/Register.vue')
			},
			//忘记密码
			{
				path: '/forgotPassword',
				name: 'forgotPassword',
				component: () => import('../views/ForgotPassword.vue')
			},
			//个人中心
			{
				path: '/personalCenter',
				name: 'personalCenter',
				component: () => import('../views/PersonalCenter/index.vue')
			},
			//文明实践
			{
				path: '/CivilizedPractice',
				name: 'CivilizedPractice',
				component: () => import('../views/CivilizedPractice/index.vue')
			},
			//文明实践
			{
				path: '/CivilizedPracticeDetail/:id',
				name: 'CivilizedPracticeDetail',
				component: () => import('../views/CivilizedPractice/detail.vue')
			}
		]
	}
]

// 创建路由对象：加载路由表（相当于是固定默认代码）
const router = new VueRouter({
	mode: 'hash', // 路径的模式，hash模式
	routes //当属性名和变量名一致可以简写变量名
})

router.beforeEach((to, from, next) => {
	// 判断是否为复制的地址栏中的链接
	console.log(from.name)
	console.log(to.path)
	const isCopiedLink = !from.name && to.path == '/'
	if (isCopiedLink) {
		// 如果是复制的链接，则重定向到首页
		next({ path: '/home' })
	} else {
		next()
	}
})

router.afterEach((route) => {
	// 从路由的元信息中获取 title 属性
	if (route.meta.title) {
		document.title = route.meta.title
		// 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
		if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
			const hackIframe = document.createElement('iframe')
			hackIframe.style.display = 'none'
			document.body.appendChild(hackIframe)
		}
	}
})

// 导入
export default router
